import React, { FunctionComponent, useEffect, useState } from "react";
import { RootState } from "../../../../Config/Store";
import { useAppSelector } from "../../../../Config/Hooks";
import {Box, Button, Grid} from "@mui/material";
import {useEquipmentWithoutSkidNavigation} from "../../../../Shared/Hooks/useEquipmentWithoutSkidNavigation";
import {ACard, Skeleton, ProgressCard} from "@atiautomacao/ati-ui-library"
import { Container } from "../../../../Shared/Components/AlarmTotalizers/AlarmTotalizers.theme";
import { truncateNumber } from "../../../../Utils/NumberUtil";
import {FindInstantDataByPowerStationReactQuery} from "./InstantDataSkidReactQuery";
import East from "@mui/icons-material/East";



const WeatherStationPlant: FunctionComponent<{powerPlantId: any, skidId: any}> = ({powerPlantId, skidId}) => {

    const navigateToEquipment = useEquipmentWithoutSkidNavigation();
    const [seriesGauge, setSeriesGauge] = useState<Array<{title: string, seriesGauge: any}>>([]);
    const userConfig = useAppSelector((state: RootState) => state.userConfigurarion);
    const {data, isLoading} = FindInstantDataByPowerStationReactQuery(powerPlantId, skidId)  //userConfig.mainUpdateInterval
    const [meteorologicalStationId, setMeteorologicalStationId] = useState()

    const extractWeather = () => {
        // Rule of intervals at 100%
        const TICK = 3;
        const ONEINTERVAL = ((100 / TICK) / 100).toFixed(2);
        const TWOINTERVAL = (1 - parseFloat(ONEINTERVAL)).toFixed(2);
        const entityValues = data?.data
        const activePower = entityValues?.activePower ?? 0
        const expectedEnergy = entityValues?.expectedEnergy ?? 0


        // Definindo valores padrão para os componentes
        const defaultWeather: Array<{ title: string, seriesGauge: any }> = [
            {
                title: 'Potência Ativa',
                seriesGauge: {
                    value: activePower,
                    intervalsTicks: [
                        [1, '#f0a12b'],
                    ],
                    unity: 'MW',
                    max: expectedEnergy,
                    barInterval: {min: {value: 0, color:"#a4f657"}, mid: {value: 0, color:"#a4f657"}, max: {value: 0, color:"#a4f657"}}
                },
            },
            {
                title: 'POA',
                seriesGauge: {
                    value: 0,
                    unity: "W/m²",
                    intervalsTicks: [
                        [1, '#f0a12b'],
                    ],
                    max: 1000,
                    barInterval: {min: {value: 0, color:"#a4f657"}, mid: {value: 0, color:"#a4f657"}, max: {value: 0, color:"#a4f657"}}
                },
            },
            {
                title: 'GHI',
                seriesGauge: {
                    value: 0,
                    unity: "W/m²",
                    intervalsTicks: [
                        [1, '#f0a12b'],
                    ],
                    max: 1200,
                    barInterval: {min: {value: 0, color:"#a4f657"}, mid: {value: 0, color:"#a4f657"}, max: {value: 0, color:"#a4f657"}}
                },
            },
            {
                title: 'Temp. do módulo (ºC)',
                seriesGauge: {
                    value: 0,
                    intervalsTicks: [
                        [ONEINTERVAL, '#a4f657'],
                        [TWOINTERVAL, '#f0a12b'],
                        [1, '#e02222'],
                    ],
                    unity: 'ºC',
                    max: 80,
                    barInterval: {min: {value: 26, color: "#FFD700"}, mid: {value: 53, color:"#a4f657"}, max: {value: 80, color: "#FF4500"}}
                },
            },
            {
                title: 'Temp. do Ar (ºC)',
                seriesGauge: {
                    value: 0,
                    intervalsTicks: [
                        [ONEINTERVAL, '#a4f657'],
                        [TWOINTERVAL, '#f0a12b'],
                        [1, '#e02222'],
                    ],
                    unity: 'ºC',
                    max: 80,
                    barInterval: {min: {value: 26, color: "#a4f657"}, mid: {value: 53, color:"#FFD700"}, max: {value: 80, color: "#FF4500"}}
                },
            },
            {
                title: 'Vel. do Vento (m/s)',
                seriesGauge: {
                    value: 0,
                    intervalsTicks: [
                        [ONEINTERVAL, '#a4f657'],
                        [TWOINTERVAL, '#f0a12b'],
                        [1, '#e02222'],
                    ],
                    unity: 'm/s',
                    max: 14,
                    barInterval: {min: {value: truncateNumber(Number(14/3),2), color: "#a4f657"}, mid: {value: 11, color: "#FFD700"}, max: {value: 14, color: "#FF4500"}}
                },
            },
            // {
            //     title: 'Umidade do Ar (%)',
            //     seriesGauge: {
            //         value: 0,
            //         intervalsTicks: [
            //             [1, '#f0a12b'],
            //         ],
            //         unity: '%',
            //         max: 100,
            //         barInterval: {min: {value: 0, color:"#a4f657"}, mid: {value: 0, color:"#a4f657"}, max: {value: 0, color:"#a4f657"}}
            //     },
            // },


        ];
        let weather = [...defaultWeather];
        weather[0].seriesGauge.value = Number((activePower/1000).toFixed(2))
        weather[0].seriesGauge.max = Number((expectedEnergy/1000).toFixed(2))
        weather[0].seriesGauge.unity = `/ ${weather[0].seriesGauge.max} MW`
        if(entityValues?.meteorologicalStation?.length > 0){
            for (let entity of entityValues?.meteorologicalStation) {
                if (entity.name.includes("POA")) {
                    weather[1].seriesGauge.value = Number(entity.value.toFixed(2));
                } else if (entity.name.includes("GHI")) {
                    weather[2].seriesGauge.value = Number(entity.value.toFixed(2));
                } else if (entity.name.includes("Temperatura do Módulo")) {
                    weather[3].seriesGauge.value = Number(entity.value.toFixed(2));
                } else if (entity.name.includes("Temperatura do Ar")) {
                    weather[4].seriesGauge.value = Number(entity.value.toFixed(2));
                } else if (entity.name.includes("Velocidade do Vento")) {
                    weather[5].seriesGauge.value = Number(entity.value.toFixed(2));
                }
            }

        }
        if(weather.length > 0) {
            setSeriesGauge(weather);
        } else {
            setSeriesGauge(defaultWeather);
        }
    }


    useEffect(() => {
        extractWeather();
        setMeteorologicalStationId(data?.data?.meteorologicalStationId)
    }, [data]);

    const handleNodeClick = (): void => {
        if(meteorologicalStationId){
            navigateToEquipment(meteorologicalStationId);
        }
    }


    if (isLoading) {
        return (
            <Box style={{paddingBottom: 10}}>
                <ACard
                    title={"Estação Meteorológica"}
                >
                    <Container data-testid="loading-skeleton">
                        <Grid container spacing={1.5} justifyContent="center">
                            {Array.from({ length: 6 }).map((_, index) => (
                                <Grid key={index.valueOf()} item style={{ display: 'flex', justifyContent: 'center', alignItems: 'center'}} xs={12} sm={4} md={4} lg={12} xl={12}>
                                    <Skeleton key={index.valueOf()} animation="wave" height={100} variant="rectangular" width={220} />
                                </Grid>
                            ))}
                        </Grid>
                    </Container>
                </ACard>
            </Box>
        );
    }

    // @ts-ignore
    return (
        <ACard
            title="Dados instantâneos"
            ariaLabel={"dashboard-skid-plant-meteorological"}

        >
            {
                <Box>
                    <Grid container spacing={1.5} justifyContent="center">
                        {/*<Gauge series={element.seriesGauge} title={element.title} />*/}
                        {seriesGauge.map((row,index) => {
                            return (
                                <Grid key={index.valueOf()} item style={{ display: 'flex', justifyContent: 'center', alignItems: 'center'}} xs={6} sm={6} md={4} lg={12} xl={12}>
                                    <ProgressCard
                                        value={row.seriesGauge.value}
                                        maxValue={row.seriesGauge.max}
                                        intervals={row.seriesGauge.barInterval}
                                        unit={row.seriesGauge.unity}
                                        label={row.title}
                                        fontSize={16}
                                        valueFontSize={15}
                                        showProgressBar={true}
                                        background="#F9F9F9"
                                        textColor="#000000"
                                        width={220}
                                        boldLabel={true}
                                        isPercentValue={false}
                                    />
                                </Grid>
                            )
                        })}
                    </Grid>
                    <Button
                        variant="text"
                        color="primary"
                        disabled={meteorologicalStationId === undefined}
                        onClick={handleNodeClick}
                        size="small"
                        fullWidth
                        startIcon={<East />}
                        sx={{
                            textTransform: 'uppercase',
                            marginTop: 0.5,
                            justifyContent: 'flex-start', // Alinha o bloco (ícone + texto) à esquerda
                            textAlign: 'left',
                            marginLeft: 0.3,
                            marginBottom: -2,
                            textDecoration: 'underline',
                            paddingLeft: '8px',
                            '&:hover': {
                                textDecoration: 'underline',
                                backgroundColor: 'transparent'
                            }

                        }}
                    >
                        Ver solarimétrica
                    </Button>
                </Box>
            }
        </ACard>
    );

}

export default WeatherStationPlant;